export enum SubscriberPreferenceType {
  TEXT = 'text',
  SINGLE_CHOICE = 'single_choice',
  MULTIPLE_CHOICE = 'multiple_choice',
  DROPDOWN = 'dropdown',
  BOOLEAN = 'boolean',
}

export enum SubscriberPreferenceDisplayType {
  RADIO_BUTTONS = 'radio_buttons',
  CHECKBOXES = 'checkboxes',
  NUMERALS = 'numerals',
  UNSTYLED = 'unstyled',
}

export interface SubscriberPreferenceOption {
  id: string;
  value: string;
}

export interface SubscriberPreference {
  id: string;
  name: string;
  description: string;
  preference_type: SubscriberPreferenceType;
  display_type: SubscriberPreferenceDisplayType;
  required: boolean;
  subscriber_preference_options: SubscriberPreferenceOption[];
  custom_field_id: string;
  value: any;
}

export interface OrganizationSubscription {
  publication_id: string;
  name: string;
  description: string;
  subscribed: boolean;
}
